import { Col, Form, Row } from "antd";
import React from "react";

import { htmlDecode } from "../utils";

import { AnswerInput } from "./AnswerInput";
import { ComplianceQuestionsProps } from "./types";

import { SanitizedHtml } from "~/Atom/SanitizedHTML";

export const ComplianceQuestions: React.FC<ComplianceQuestionsProps> = ({
  complianceQuestions,
  formik,
}) => (
  <div
    style={{
      maxHeight: "50vh",
      borderTop: "1rem",
      padding: "0.25rem",
    }}
  >
    {complianceQuestions.map((complianceQuestion, idx) => (
      <Row key={idx}>
        <Col span={24}>
          {complianceQuestion.description && (
            <SanitizedHtml
              dirtyHtml={htmlDecode(complianceQuestion.description)}
            />
          )}
          {complianceQuestion.questions?.map((question, idx) => (
            <Form.Item key={idx}>
              <AnswerInput question={question} formik={formik} />
            </Form.Item>
          ))}
        </Col>
      </Row>
    ))}
  </div>
);
